import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../../themes";

export const ResultBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.success ? 3 : 8}px;
  margin-top: 20px;  
  margin-bottom: 20px;  
  padding: ${props => props.success ? '10px 0' : '10px 20px'};
  background: ${props => props.success ? colors.background.blueRomance : colors.background.bridesmaid};
  border: 1px solid ${props => props.success ? colors.border.salem : 'transparent'};
  border-radius: 8px;
  >input {
    width: 100%;
  }
  @media only screen and ${sizes.max991} {
    margin-top: 4vw;
    margin-bottom: 4vw;
  }
`;

export const Price = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(33)}
  line-height: 120%;
  display: flex;
  align-items: center;
  text-align: center;
  color: ${colors.text.ebony};
`;

export const Nights = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(16)}
  line-height: 120%;
  display: flex;
  align-items: center;
  text-align: center;
  color: ${colors.text.ebony};
`;

export const Deposit = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(16)}
  line-height: 120%;
  display: flex;
  align-items: center;
  text-align: center;
  padding-top: 6px;
  color: ${colors.text.ebony};
`;

export const AvailableBerths = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-weight: ${props => props.bold ? 900 : 700};
  ${fontSize(16)}
  line-height: 120%;
  text-align: center;
  color: ${colors.border.salem};
`;

export const Text = styled.span`
  font-style: normal;
  font-weight: ${props => props.bold ? 700 : 400};
  text-align: ${props => props.center ? "center" : "left" };
  ${fontSize(14)}
  line-height: 120%;
  color: ${colors.text.mineShaft};
  span {
    font-weight: 700;
    color: ${colors.text.kleinBlue};
    cursor: pointer;
  }
`;
